/* eslint-disable  */
import React, {useEffect} from 'react';
import renderHTML from 'react-render-html';
import {documentToHtmlString} from '@contentful/rich-text-html-renderer';
import {isMobile} from 'mobile-device-detect';
import FocusLock from 'react-focus-lock';

const ArticleModal = props => {

    const formatDate = (date) => {
        if(date == undefined){
            return ``;
        }
        const months = ["N/A", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const numericalDate = date.split("T");
        const splitDate = numericalDate[0].split("-");
        const year = splitDate[0];
        let month = splitDate[1];
        month = month.charAt(0) === `0` ? month.substring(1) : month;
        const day = splitDate[2];
         
        return day + " " + months[month] + " " + year;
    }

    useEffect(() => {
        /* eslint-disable jsx-no-target-blank*/
        const allLinks = document.querySelectorAll(`a`);
        for (let i = 0; i < allLinks.length; i++) {
            allLinks[i].setAttribute(`target`, `_blank`);
            allLinks[i].setAttribute(`rel`, `noopener norefferrer`);
        }
    });

    return (
        props.display ? <div style={{display: props.display}} className="article-modal-container">
            <FocusLock autoFocus={true}>
            <article className="article"
                 role="alert"
                 aria-labelledby="article_title"
                 aria-modal="true"
                 tabIndex="0"
            >
                <img className="publisher-logo" src={`https:${props.data.publisherLogo.fields.file.url}`} alt={props.data.publisherLogo.fields.title}/>
                <h1 id="article_title">{props.data.title}</h1>
                <p className="author">{props.data.author}</p>
                <p className="date" >{formatDate(props.data.date)}</p>
                <p className="copyright">{props.data.copyright}</p>
                <div>
                    {props.data.articleImage && <div className="article-image-container">
                        <img src={`https:${props.data.articleImage.fields.file.url}`} align={isMobile ? `middle` : `right`} alt={props.data.articleImageDescription} />
                        <p>{props.data.imageCopyright}</p>
                    </div>}
                    {renderHTML(documentToHtmlString(props.data.body))}
                </div>
                {props.data.license && <p className="license-toast">{props.data.license}</p>}
            </article>
            <img src={`/images/exit.svg`}
                 className="exit-btn"
                 tabIndex="0"
                 aria-label="Close Modal Button"
                 alt="Close Modal Button"
            onKeyDown={event => {
                if (event.keyCode === 13) {
                    props.closeModal('ArticleClose');
                } else if (event.keyCode === 32) {
                    props.closeModal('ArticleClose');
                }
            }}
            
            onClick={() => props.closeModal('ArticleClose')}/>
        </FocusLock>
        </div> : null
    );
};
export default ArticleModal;
